const MANUAL_MODE_STORAGE_KEY = 'doc-capture-manual-mode';

export const readPrefersManualMode = (): boolean => {
  try {
    return sessionStorage.getItem(MANUAL_MODE_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const writePrefersManualMode = (prefersManualMode: boolean) => {
  try {
    sessionStorage.setItem(MANUAL_MODE_STORAGE_KEY, String(prefersManualMode));
  } catch {
    // ignore
  }
};
